export default "__VITE_ASSET__DQG5Z0E9__"